import fetch from 'isomorphic-fetch';

import {
  WP_JSON_API_REQUEST,
  WP_JSON_API_ERROR,
  WP_JSON_API_SUCCESS,
  SELECT_TRIP_OR_TRAILHEAD,
  DESELECT_TRIP_OR_TRAILHEAD,
} from '../common/actionTypes';

// following 4 action creators handle requesting trailhead data from the WP JSON API
const requestWpJsonData = () => ({
  type: WP_JSON_API_REQUEST,
});

const receiveWpJsonData = (json, category) => ({
  type: WP_JSON_API_SUCCESS,
  json,
  category,
});

const handleWpJsonError = (error) => ({
  type: WP_JSON_API_ERROR,
  error,
});

export const fetchWpJsonApiData = (type) => {
  const typeMap = type === 'trips' ? 'trail' : 'trailhead'; // maps more semantic meaning to api path
  const { host, protocol} = window.location;
  const api = `wp-json/wp/v2/crb_${typeMap}`;
  const params = 'per_page=100';
  const url = `${protocol}//${host}/${api}?${params}`;

  return (dispatch) => {
    dispatch(requestWpJsonData());
    return fetch(url)
      .then((res) => {
        if (!res.ok) {
          dispatch(handleWpJsonError(res.statusText));
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(json => dispatch(receiveWpJsonData(json, type)))
      .catch(error => dispatch(handleWpJsonError(error)));
  };
};

// action creators to handle tracking a selecting / deselecting a trip or trail
export const selectTripTrailhead = (id, selector) => ({
  type: SELECT_TRIP_OR_TRAILHEAD,
  id,
  selector,
});

export const deselectTripTrailhead = () => ({
  type: DESELECT_TRIP_OR_TRAILHEAD,
});



// WEBPACK FOOTER //
// ./map/actions/tripsTrailheadsActions.js